import { Directive, OnInit, inject } from '@angular/core'

import { FlxSwitchComponent } from '@flowx/angular-ui-toolkit'
import { theme } from '@flowx/core-sdk'
import { ThemeComponent, getComponentStyles } from '@flowx/core-theme'

import { FlxComponentThemeBaseDirective } from './component-theme-base.directive'

import { ComponentType } from '../injectors'

@Directive({
  selector: 'flx-switch',
  standalone: true,
  hostDirectives: [FlxComponentThemeBaseDirective],
  providers: [{ provide: ComponentType, useValue: ThemeComponent.Switch }],
})
export class FlxSwitchThemeDirective implements OnInit {
  switchComponent = inject(FlxSwitchComponent)

  ngOnInit(): void {
    const checkboxClass = getComponentStyles(ThemeComponent.Checkbox, theme())
    const switchClass = getComponentStyles(ThemeComponent.Switch, theme())
    this.switchComponent.switchClass.set(`${switchClass} ${checkboxClass} flx-themed`)
  }
}
